import React, { useCallback, useRef, useState } from 'react';

import api from '../../../../services';

import AutoComplete from 'material-ui/AutoComplete';
import { Checkbox } from 'material-ui';

function RegisterClass({
    changeField,
    clearError,
    getError,
    confirmed,
    underStyle,
    registerClass,
}) {
    const [classes, setClasses] = useState([]);
    const registerClassRef = useRef(registerClass);
    registerClassRef.current = registerClass;

    const changeAutoComplete = useCallback((searchText) => {
        changeField([
            {
                field: 'registerClass.name',
                value: searchText,
            },
            {
                field: 'registerClass._id',
                value: '',
            },
            {
                field: 'registerClass.iacsRegister',
                value: false,
            },
        ]);

        setClasses([]);

        queueMicrotask(() => {
            const rc = registerClassRef.current;
            if (!rc._id && searchText) {
                changeField([{
                    field: 'errors',
                    value: {
                        field: 'registerClass',
                        messages: ['Please select register class from dropdown'],
                    },
                    type: 'array',
                }]);
            }
            if (searchText) {
                api.findClasses(searchText)
                    .then((response) => {
                        if (response.status === 200) {
                            const regClasses = response.data.data.map(regClass => ({
                                name: regClass.name,
                                regClass,
                            }));

                            if (!regClasses.length) {
                                setClasses([]);

                                changeField({
                                    field: 'registerClass._id',
                                    value: '',
                                });
                            } else {
                                setClasses(regClasses);
                            }
                        }
                    })
                    .catch((error) => {
                        console.error('Error AutoComplete Register classes - RegisterClass component', error);
                        return null;
                    });
            } else {
                clearError('registerClass');
            }
        });
    }, [changeField, clearError]);

    const chooseAutoComplete = useCallback((updateProperties) => {
        setClasses([]);

        changeField([{
            field: 'registerClass',
            value: updateProperties.regClass,
        }]);

        clearError('registerClass');
    }, [changeField, clearError]);

    const checked = !!registerClass.iacsRegister;
    const disabled = !!registerClass.name;

    return (
        <div style={{ display: 'flex' }}>
            <AutoComplete
                name='registerClass'
                disabled={confirmed}
                floatingLabelText='Register Class(Class)'
                searchText={registerClass.name}
                dataSource={classes}
                dataSourceConfig={{ text: 'name', value: 'registerClass' }}
                onUpdateInput={changeAutoComplete}
                onNewRequest={chooseAutoComplete}
                filter={AutoComplete.noFilter}
                errorText={getError('registerClass')}
                listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                popoverProps={{
                    canAutoPosition: true,
                }}
                style={{ width: '70%' }}
                fullWidth

                underlineStyle={underStyle}
            />
            <Checkbox
                style={{ width: '30%', margin: '40px 0 0 20px' }}
                label='IACS'
                checked={checked}
                disabled={disabled}
                onCheck={() => changeField([{ field: 'registerClass.iacsRegister', value: !registerClass.iacsRegister }])}
            />
        </div>
    );
}

export default RegisterClass;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/RegisterClass.jsx